import { Button } from "../../Button";
import { getAllUnitsList, getSearchedUnitsList } from "../../../api/unit/unit-list";
import { getUnitTreeList } from "../../../api/unit/unit-list";
import { Link } from "react-router-dom";
import { PropTypes } from "prop-types";
import { QueryLoader } from "../../Loader";
import { StyledUnitsPage } from "../../../styles/StyledUnitsPage";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import AddIcon from "../../../assets/img/icons/add.svg";
import convertStringToColor from "../../../helpers/util/convertStringToColor";
import UnitTreeItem from "./UnitTreeItem";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";

export const UnitTree = ({ phrase, myUnits, id, upperUnitId }) => {
	const { axiosPrivate } = useAxiosPrivate();
	const { isLoading, isError, error, data, refetch } = useQuery(["unitslist", phrase, id, upperUnitId], () => {
		if (id) {
			return getUnitTreeList(axiosPrivate, id);
		} else {
			if (!phrase) return getAllUnitsList(axiosPrivate);
			if (phrase) return getSearchedUnitsList(axiosPrivate, phrase);
		}
	});

	const [parents, setParents] = useState(false);
	const [myUnitsList, setMyUnitsList] = useState([]);
	const [openDropdowns, setOpenDropdowns] = useState({});
	const [currentUserId, setCurrentUserId] = useState(null);

	useEffect(() => {
		const fetchUser = async () => {
			try {
				const res = await axiosPrivate.get("/user/profile.json");
				setCurrentUserId(res.data.id);
			} catch (err) {
				console.error("Failed to fetch user profile", err);
			}
		};
		fetchUser();
	}, []);

	useEffect(() => {
		if (id) {
			if (isError) console.log(error);
			if (!isLoading && !isError) {
				const res = [];
				checkParents([], data, id, res);
				setParents(res);
			}
		} else {
			if (!isLoading && !isError && data) {
				const resArr = [];
				const filteredUnits = data.filter((unit) => unit.createdBy === currentUserId);
				filteredUnits.map((e) => returnMyUnits(e, resArr));
				setMyUnitsList(resArr);
				for (const unit of data) {
					setOpenDropdowns({ ...openDropdowns, [unit.id]: false });
				}
			}
		}
	}, [isLoading, phrase, data, currentUserId, isError, id]);

	const handleUnitDeleted = async () => {
		 await refetch();
	};

	if (isError) {
		console.log(error);
	}

	return (
		<>
			{isLoading || isError ? (
				<QueryLoader />
			) : id ? (
				!isLoading &&
				!isError &&
				parents && (
					<StyledUnitsPage>
						<UnitTreeItem
							key={data.id}
							id={data.id}
							name={data.name}
							color={convertStringToColor(data.name)}
							state={"link"}
							unitChildren={data.children}
							direction={"leftcenter"}
							myUnit={data.myUnit}
							parentWay={parents}
							targetId={parseInt(id)}
							onUnitDeleted={handleUnitDeleted}
						/>
					</StyledUnitsPage>
				)
			) : (
				<>
					<StyledUnitsPage>
						{myUnitsList.length === 0 ? (
							<p>You haven’t created any units yet.</p>
						) : (
							myUnitsList.map((e, i) => (
								<UnitTreeItem
									key={i}
									id={e.id}
									name={e.name}
									color={convertStringToColor(e.name)}
									state="link-single"
									openDropdowns={openDropdowns}
									setOpenDropdowns={setOpenDropdowns}
									unitChildren={e.children}
									direction={"leftcenter"}
									myUnit={e.myUnit}
									onUnitDeleted={handleUnitDeleted}
								/>
							))
						)}
						<Link to={"/add-unit"}>
							<Button icon={AddIcon}>Add new unit</Button>
						</Link>
					</StyledUnitsPage>
				</>
			)}
		</>
	);
};

UnitTree.propTypes = {
	id: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
	upperUnitId: PropTypes.any,
	phrase: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
	myUnits: PropTypes.bool,
};

UnitTree.defaultProps = {
	id: false,
	upperUnitId: false,
	phrase: false,
	myUnits: false,
};

function returnMyUnits(unit, arr) {
	if (unit.myUnit) arr.push(unit);
	if (unit?.children) {
		if (unit.children.length > 0) unit.children.map((e) => returnMyUnits(e, arr));
	}
}

function checkParents(currentWay, unit, targetId, targetWay) {
	if (parseInt(unit.id) === parseInt(targetId)) {
		targetWay.push(...currentWay);
	} else {
		if (unit.children) unit.children.map((e) => checkParents([...currentWay, parseInt(unit.id)], e, targetId, targetWay));
	}
}

export default UnitTree;
